import { render, staticRenderFns } from "./UserProfileOnboarding.vue?vue&type=template&id=35cab907&"
import script from "./UserProfileOnboarding.vue?vue&type=script&lang=js&"
export * from "./UserProfileOnboarding.vue?vue&type=script&lang=js&"
import style0 from "./UserProfileOnboarding.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports